export default __webpack_public_path__ + "static/media/aboutUsPic2.e43b5737.jpg";